import {
  Component,
  OnInit,
  EventEmitter,
  Output,
  Input,
  SimpleChanges,
} from '@angular/core';
import {
  FormControl,
  FormBuilder,
  FormGroup,
  Validators,
  FormArray,
} from '@angular/forms';
import { CommonService } from 'src/app/services/common-services/common.service';
import { environment } from 'src/environments/environment';

import { OtherValueStatePayload } from '../create-rfq/create-rfq.component';

@Component({
  selector: 'app-material-dropdown',
  templateUrl: './material-dropdown.component.html',
  styleUrls: ['./material-dropdown.component.scss'],
})
export class MaterialDropdownComponent {
  @Output() backMaterial = new EventEmitter<string>();
  @Output() materialParent = new EventEmitter<any>();
  @Output() onInputOtherMaterial = new EventEmitter<OtherValueStatePayload>();
  @Input() otherMaterialValue = '';

  baseUrl = environment.BASE_URL;
  // materialData: any[] = [];
  clickedMaterial: any = 0;
  searchForm!: FormGroup;
  materialsForm!: FormGroup;
  selectedMaterial: any[] = [];
  filteredData: any[] = [];

  @Input('materialData') materialData!: any;
  @Input('alreadyMaterials') alreadyMaterials!: any;

  isOtherMaterialInputVisible = false;
  isSaveBtnActive = true;

  constructor(
    private formBuilder: FormBuilder,
    private profileData: CommonService
  ) {}

  ngOnChanges() {
    if (this.otherMaterialValue) {
      this.isSaveBtnActive = true;
      this.isOtherMaterialInputVisible = true;
    }

    if (this.materialData) {
      this.materialData = this.materialData.map((i: any) => {
        return { ...i };
      });
      this.filteredData = this.materialData;
    }
  }

  ngOnInit(): void {
    // this.getMaterial();
    this.searchForm = this.formBuilder.group({
      searchText: [''],
    });
    this.materialsForm = this.formBuilder.group({
      material: [''],
    });
    this.filterItems();

    this.setAlreadyMaterial();
  }

  handleOthersMaterialInputVisibility(item: any) {
    const name = (item.name as string).toLocaleLowerCase();
    if (name === 'others') {
      this.isOtherMaterialInputVisible = item.isChecked;

      if(!item.isChecked){
        this.otherMaterialValue = ''
      }
    }

    this.handleSaveBtn();
  }

  setAlreadyMaterial() {
    if (this.alreadyMaterials?.length) {
      this.alreadyMaterials?.forEach((ele: any) => {
        for (let val of this.materialData) {
          if (val?.id == ele?.id) {
            val.isChecked = true;
          }
        }
      });
    }
    this.materialParent.emit(this.materialData);
  }

  handleSaveBtn() {
    this.isSaveBtnActive = this.isOtherMaterialInputVisible
      ? !!this.otherMaterialValue
      : true;

  }
  // getMaterial() {
  //   this.profileData.getData(`${this.baseUrl}common-service/material`).subscribe(res => {
  //     this.materialData = res.response;
  //     if(this.materialData){
  //       this.materialData.forEach((item:any)=>{
  //         item['isChecked'] = false;
  //       })
  //     }
  //   })
  // }
  filterItems() {
    const searchText = this.searchForm
      .get('searchText')
      ?.valueChanges.subscribe((value) => {
        this.filteredData = this.materialData.filter((item: any) =>
          item.name.toLowerCase().includes(value.toLowerCase())
        );

        if (value == '') {
          this.filteredData = this.materialData;
        }
      });

    // if(!this.materialData){
    //   return [];
    // }
    // return this.materialData.filter((item:any) =>
    //   item.materialName.toLowerCase().includes(searchText)
    // );
  }
  getSelected() {
    // console.log('materialData', this.materialData);
    // this.materialData.forEach((item:any)=>{
    //   if(item.isChecked){
    //     this.selectedMaterial.push({name: item.materialName, id: item.materialId});
    //   }
    // })
    // console.log(this.selectedMaterial);
    this.materialParent.emit(this.materialData);
    this.backMaterial.emit();
    this.onInputOtherMaterial.emit({
      key: 'material',
      value: this.otherMaterialValue,
    });
  }

  clickMaterial(index: any, item: any) {
    //console.log(item);
    this.clickedMaterial = index;
  }
  // isMaterialChecked(index: any) {
  //   let isChecked = false;
  //   this.materialData[index].materialGrade.forEach((grade: any) => {
  //     if (grade.isChecked) {
  //       isChecked = true
  //     }
  //   })
  //   return isChecked;
  // }

  backClick() {
    this.backMaterial.emit();
    this.unCheckAll();
  }

  unCheckAll() {
    this.isOtherMaterialInputVisible = false;
    this.onInputOtherMaterial.emit({
      key: 'material',
      value: '',
    });
    this.otherMaterialValue = '';
    this.materialData.forEach((item: any) => {
      item.isChecked = false;
    });

    // this.materialParent.emit(this.materialData);
  }
}
